var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/ui-components/src/lib/modules/scene/scene.controller.ts
import { html as html2, render } from "lit";

// libs/ui-components/src/lib/modules/scene/scene.style.ts
import { css, unsafeCSS } from "lit";
var defaultConfig = {
  sceneBackgroundColor: "var(--color-background-bg-primary)"
};
var sceneStyle = (config) => {
  const _config = { ...defaultConfig, ...config };
  return css`

      :host {
          display: flex;
          --scene-background-color: ${unsafeCSS(_config.sceneBackgroundColor)};
      }

      .scene-container {
          min-height: 50px;
          min-width: 50px;
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          will-change: width, height, transform, filter;
      }
  `;
};

// libs/ui-components/src/lib/modules/scene/scene-wrapper.element.ts
import { css as css2, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { ContextProvider } from "@lit/context";

// libs/ui-components/src/lib/modules/scene/scene-context.token.ts
import { createContext } from "@lit/context";
var sceneContext = createContext(Symbol("scene context"));

// libs/ui-components/src/lib/modules/scene/scene-context.ts
import { firstValueFrom, Subject } from "rxjs";
var SceneContext = class {
  constructor() {
    this.animationInProgress = false;
    this.animationInStart$ = new Subject();
    this.animationInEnd$ = new Subject();
    this.animationOutStart$ = new Subject();
    this.animationOutEnd$ = new Subject();
  }
  get animationInStart() {
    return firstValueFrom(this.animationInStart$);
  }
  get animationInEnd() {
    return firstValueFrom(this.animationInEnd$);
  }
  get animationOutStart() {
    return firstValueFrom(this.animationOutStart$);
  }
  get animationOutEnd() {
    return firstValueFrom(this.animationOutEnd$);
  }
  animationInStartNext() {
    this.animationInProgress = true;
    this.animationInStart$.next();
  }
  animationInEndNext() {
    this.animationInProgress = false;
    this.animationInEnd$.next();
  }
  animationOutStartNext() {
    this.animationInProgress = true;
    this.animationOutStart$.next();
  }
  animationOutEndNext() {
    this.animationInProgress = false;
    this.animationOutEnd$.next();
  }
};

// libs/ui-components/src/lib/modules/scene/scene-wrapper.element.ts
var SceneWrapperElement = class extends LitElement {
  constructor() {
    super();
    this.context = new ContextProvider(this, { context: sceneContext });
    this.context.setValue(new SceneContext());
  }
  animationInStart() {
    const context = this.context.value;
    context.animationInStartNext();
  }
  animationInEnd() {
    const context = this.context.value;
    context.animationInEndNext();
  }
  animationOutStart() {
    const context = this.context.value;
    context.animationOutStartNext();
  }
  animationOutEnd() {
    const context = this.context.value;
    context.animationOutEndNext();
  }
  render() {
    return html`<slot></slot>`;
  }
};
SceneWrapperElement.tagName = "inch-scene-wrapper";
SceneWrapperElement.styles = css2`
      :host {
          background-color: var(--scene-background-color);
          will-change: transform;
          transform: translate3d(0, 0, 0);
          height: fit-content;
          box-sizing: border-box;
          position: relative;
          display: block;
      }
  `;
SceneWrapperElement = __decorateClass([
  customElement(SceneWrapperElement.tagName)
], SceneWrapperElement);

// libs/ui-components/src/lib/modules/scene/animations/shift.animation.ts
import { appendStyle, isSafari } from "@one-inch-community/core/lit";
function shiftAnimation() {
  const initStyle = {
    position: "absolute",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    zIndex: "9",
    backfaceVisibility: "hidden",
    height: isSafari() ? "110%" : ""
  };
  const resetStyle = {
    position: "",
    top: "",
    left: "",
    bottom: "",
    right: "",
    zIndex: "",
    transform: "",
    filter: "",
    backfaceVisibility: "",
    height: ""
  };
  const animationConfig = {
    duration: 500,
    easing: "cubic-bezier(.2, .8, .2, 1)"
  };
  return {
    preparation: async (upLayer, downLayer, isBack) => {
      appendStyle(upLayer, {
        ...initStyle,
        zIndex: "9",
        transform: isBack ? "translate3d(0, 0, 0)" : "translate3d(110%, 0, 0)"
      });
      appendStyle(downLayer, {
        ...initStyle,
        zIndex: "8",
        transform: isBack ? "translate3d(-110%, 0, 0)" : "translate3d(0, 0, 0)"
      });
    },
    transition: async (upLayer, downLayer, isBack) => {
      await Promise.all([
        upLayer.animate([
          { transform: isBack ? "translate3d(0, 0, 0)" : "translate3d(110%, 0, 0)" },
          { transform: isBack ? "translate3d(110%, 0, 0)" : "translate3d(0, 0, 0)" }
        ], animationConfig),
        downLayer.animate([
          {
            transform: isBack ? "translate3d(-110%, 0, 0)" : "translate3d(0, 0, 0)"
          },
          {
            transform: isBack ? "translate3d(0, 0, 0)" : "translate3d(-110%, 0, 0)"
          }
        ], animationConfig).finished
      ]);
      appendStyle(upLayer, { ...resetStyle });
      appendStyle(downLayer, { ...resetStyle });
    }
  };
}

// libs/ui-components/src/lib/modules/scene/animations/slide.animation.ts
import { appendStyle as appendStyle2, isSafari as isSafari2 } from "@one-inch-community/core/lit";
function slideAnimation() {
  const initStyle = {
    position: "absolute",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    zIndex: "9",
    backfaceVisibility: "hidden",
    height: isSafari2() ? "100%" : ""
  };
  const resetStyle = {
    position: "",
    top: "",
    left: "",
    bottom: "",
    right: "",
    zIndex: "",
    transform: "",
    filter: "",
    backfaceVisibility: "",
    willChange: "",
    height: ""
  };
  const animationConfig = {
    duration: 800,
    easing: "cubic-bezier(.2, .8, .2, 1)"
  };
  return {
    preparation: async (upLayer, downLayer, isBack) => {
      appendStyle2(upLayer, {
        ...initStyle,
        zIndex: "9",
        transform: isBack ? "translate3d(0, 0, 0)" : "translate3d(100%, 0, 0)"
      });
      appendStyle2(downLayer, {
        ...initStyle,
        zIndex: "8",
        willChange: "transform, filter",
        transform: isBack ? "translate3d(-50%, 0, 0) scale(.9)" : "translate3d(0, 0, 0) scale(1)",
        filter: isBack ? "blur(3px)" : "blur(0)"
      });
    },
    transition: async (upLayer, downLayer, isBack) => {
      await Promise.all([
        upLayer.animate([
          { transform: isBack ? "translate3d(0, 0, 0)" : "translate3d(105%, 0, 0)" },
          { transform: isBack ? "translate3d(105%, 0, 0)" : "translate3d(0, 0, 0)" }
        ], animationConfig),
        downLayer.animate([
          {
            transform: isBack ? "translate3d(-50%, 0, 0) scale(.9)" : "translate3d(0, 0, 0) scale(1)",
            filter: isBack ? "blur(3px)" : "blur(0)"
          },
          {
            transform: isBack ? "translate3d(0, 0, 0) scale(1)" : "translate3d(-50%, 0, 0) scale(.9)",
            filter: isBack ? "blur(0)" : "blur(3px)"
          }
        ], animationConfig).finished
      ]);
      appendStyle2(upLayer, { ...resetStyle });
      appendStyle2(downLayer, { ...resetStyle });
    }
  };
}

// libs/ui-components/src/lib/modules/scene/animations/noop.animation.ts
import { asyncTimeout } from "@one-inch-community/core/async";
function noopAnimation() {
  return {
    preparation: async () => void 0,
    transition: async () => {
      await asyncTimeout(100);
    }
  };
}

// libs/ui-components/src/lib/modules/scene/scene.controller.ts
import { appendStyle as appendStyle3 } from "@one-inch-community/core/lit";
import { ScrollViewProviderElement } from "@one-inch-community/ui-components/scroll";
import { asyncFrame } from "@one-inch-community/core/async";
var SceneController = class {
  constructor(rootSceneName, config, animation = slideAnimation()) {
    this.rootSceneName = rootSceneName;
    this.config = config;
    this.animation = animation;
    this.sceneStack = [];
    this.sceneContainer = buildSceneContainer();
    this.transitionInProgress = false;
  }
  static {
    this.styles = sceneStyle;
  }
  get activeScene() {
    return this.sceneStack[this.sceneStack.length - 1];
  }
  render(config) {
    if (this.transitionInProgress) {
      return html2`${this.sceneContainer}`;
    }
    const isFirstRender = !this.currentScenes;
    this.currentScenes = config;
    const sceneName = this.getCurrentSceneName();
    const currentSceneConfig = this.config[sceneName];
    const isLazyRenderScene = currentSceneConfig.lazyRender ?? false;
    if (!isLazyRenderScene || isFirstRender) {
      const sceneFactory = this.getScene(sceneName);
      if (!sceneFactory) {
        throw new Error(`Scene not exist`);
      }
      const sceneWrapper = this.buildSceneWrapper(sceneFactory(), sceneName);
      this.clearContainer();
      this.sceneContainerAppendChild(sceneWrapper);
      this.applySceneConfigBySceneName(sceneName);
    }
    return html2`${this.sceneContainer}`;
  }
  async nextTo(sceneName) {
    if (this.transitionInProgress) return;
    await this.transition(sceneName);
    this.sceneStack.push(sceneName);
  }
  async back() {
    if (this.transitionInProgress) return;
    const sceneName = this.sceneStack[this.sceneStack.length - 2] ?? this.rootSceneName;
    await this.transition(sceneName, true);
    this.sceneStack.pop();
  }
  resetScene() {
    this.sceneStack = [];
  }
  getCurrentSceneName() {
    let currentScene = this.rootSceneName;
    if (this.sceneContainer.firstChild) {
      currentScene = this.sceneContainer.firstChild.id;
    }
    return currentScene;
  }
  getCurrentScene() {
    if (!this.currentScenes) return null;
    const currentScene = this.getCurrentSceneName();
    return this.getScene(currentScene);
  }
  async transition(sceneName, isBack) {
    this.transitionInProgress = true;
    try {
      const currentScene = this.getCurrentSceneName();
      if (currentScene === sceneName) return;
      const nextSceneFactory = this.getScene(sceneName);
      if (!nextSceneFactory) throw new Error(`Scene ${sceneName} not exist`);
      const nextSceneWrapper = this.buildSceneWrapper(nextSceneFactory(), sceneName);
      const currentSceneWrapper = this.sceneContainer.firstChild;
      const upScene = isBack ? currentSceneWrapper : nextSceneWrapper;
      const downScene = !isBack ? currentSceneWrapper : nextSceneWrapper;
      isBack ? upScene.animationOutStart() : upScene.animationInStart();
      isBack ? downScene.animationOutStart() : downScene.animationInStart();
      this.sceneContainerAppendChild(nextSceneWrapper);
      await asyncFrame();
      const nextSceneWrapperRect = nextSceneWrapper.getBoundingClientRect();
      const currentSceneWrapperRect = currentSceneWrapper.getBoundingClientRect();
      await this.animation.preparation(upScene, downScene, isBack ?? false);
      if (nextSceneWrapperRect.height > currentSceneWrapperRect.height) {
        this.applySceneConfigBySceneName(sceneName);
      }
      await Promise.all([
        this.animation.transition(upScene, downScene, isBack ?? false),
        this.resizeContainer(nextSceneWrapperRect, currentSceneWrapperRect)
      ]);
      if (nextSceneWrapperRect.height < currentSceneWrapperRect.height) {
        this.applySceneConfigBySceneName(sceneName);
      }
      appendStyle3(this.sceneContainer, {
        width: "",
        height: ""
      });
      this.sceneContainer.firstChild && this.sceneContainer.removeChild(this.sceneContainer.firstChild);
      isBack ? upScene.animationOutEnd() : upScene.animationInEnd();
      isBack ? downScene.animationOutEnd() : downScene.animationInEnd();
    } finally {
      this.transitionInProgress = false;
    }
  }
  getScene(sceneName) {
    if (!this.currentScenes) return null;
    return this.currentScenes[sceneName] ?? null;
  }
  clearContainer() {
    while (this.sceneContainer.firstChild) {
      this.sceneContainer.removeChild(this.sceneContainer.firstChild);
    }
  }
  buildSceneWrapper(content, name) {
    const sceneWrapper = document.createElement(SceneWrapperElement.tagName);
    sceneWrapper.id = name;
    sceneWrapper.classList.add("scene-wrapper", name);
    render(content, sceneWrapper);
    return sceneWrapper;
  }
  sceneContainerAppendChild(sceneWrapper) {
    this.sceneContainer.appendChild(sceneWrapper);
  }
  applySceneConfigBySceneName(sceneName) {
    const config = this.config[sceneName];
    this.applySceneSizes(config);
  }
  applySceneSizes(config) {
    const formatValue = (value) => {
      if (!value) return "";
      return typeof value === "number" ? `${value}px` : value;
    };
    if (config.maxHeight) {
      this.sceneContainer.maxHeight = parseInt(config.maxHeight.toString());
    }
    appendStyle3(this.sceneContainer, {
      minWidth: formatValue(config.minWidth),
      maxWidth: formatValue(config.maxWidth)
    });
  }
  async resizeContainer(nextRect, currentRect) {
    const fromKeyframe = {
      height: `${currentRect.height}px`,
      width: `${currentRect.width}px`
    };
    const toKeyframe = {
      height: `${nextRect.height}px`,
      width: `${nextRect.width}px`
    };
    appendStyle3(this.sceneContainer, fromKeyframe);
    await this.sceneContainer.animate([
      fromKeyframe,
      toKeyframe
    ], {
      duration: 500,
      easing: "cubic-bezier(.2, .8, .2, 1)"
    }).finished;
    appendStyle3(this.sceneContainer, toKeyframe);
  }
};
function buildSceneContainer() {
  const sceneContainer = document.createElement(ScrollViewProviderElement.tagName);
  sceneContainer.id = "scene-container";
  sceneContainer.classList.add("scene-container");
  return sceneContainer;
}

// libs/ui-components/src/lib/modules/scene/scene-lazy-value.ts
import { directive } from "lit/directive.js";
import { AsyncDirective } from "lit/async-directive.js";
var SceneLazyValue = class extends AsyncDirective {
  render(host, valueFactory) {
    if (!this.controller) {
      this.controller = new SceneLazyValueReactiveController(
        valueFactory,
        (value) => this.setValue(value)
      );
      host.addController(this.controller);
    }
    return valueFactory();
  }
};
var SceneLazyValueReactiveController = class {
  constructor(valueFactory, update) {
    this.valueFactory = valueFactory;
    this.update = update;
  }
  hostUpdate() {
    const nextValue = this.valueFactory();
    if (nextValue !== this.lastValue) {
      this.lastValue = nextValue;
      this.update(nextValue);
    }
  }
};
var sceneLazyValue = directive(SceneLazyValue);
export {
  SceneController,
  noopAnimation,
  sceneContext,
  sceneLazyValue,
  shiftAnimation,
  slideAnimation
};
//# sourceMappingURL=index.esm.js.map
